import { Card, CardContent, CardHeader, List } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useImpersonation } from '../hooks/useImpersonationStore';
import { ImpersonationUserListItem } from './ImpersonationUserListItem';

const currentUserTitleMessage = defineMessage({
  id: 'impersonation.currentUserTitle',
  defaultMessage: 'Usuario actual',
});

/**
 * Card showing who the superadmin is currently impersonating, above the user search field.
 */
export function CurrentImpersonatedUserCard() {
  const { impersonatedUser } = useImpersonation();
  const $t = useIntl().formatMessage;

  if (!impersonatedUser) {
    return null;
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader
        title={$t(currentUserTitleMessage)}
        titleTypographyProps={{
          variant: 'subtitle1',
        }}
      />
      <CardContent sx={{ pt: 0, '&:last-child': { pb: 1 } }}>
        <List disablePadding>
          <ImpersonationUserListItem user={impersonatedUser} />
        </List>
      </CardContent>
    </Card>
  );
}
